import { render } from "./RefreshIcon.vue?vue&type=template&id=5a5a9772"
const script = {}
script.render = render

export default script